export default __webpack_public_path__ + "static/media/mainpic5.08b3feff.png";